module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', [_c('app-header'), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px auto",
      "margin-top": "80px"
    }
  }, [_c('div', {
    staticClass: "postingtitle",
    staticStyle: {
      "text-align": "center",
      "border-bottom": "1px solid rgb(238,238,238)",
      "height": "120px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.project.projectName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('Avatar', {
    staticStyle: {
      "background-color": "#87d068"
    },
    attrs: {
      "icon": "person"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("创建时间：" + _vm._s(_vm.dateFormat(_vm.project.creationTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer"
    },
    on: {
      "mouseenter": _vm.showUserDetail,
      "mouseleave": _vm.hideUserDetail
    }
  }, [_vm._v(_vm._s(_vm.userDetail.nickName))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUserDetail),
      expression: "isShowUserDetail"
    }],
    staticStyle: {
      "width": "300px",
      "height": "160px",
      "background-color": "rgb(254,254,254)",
      "box-shadow": "1px 1px 5px 0px rgba(50, 50, 50, 0.75)",
      "border": "1px solid #cacaca",
      "border-radius": "3px",
      "position": "relative",
      "top": "10px",
      "left": "350px"
    }
  }, [_c('dl', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('dt', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('Avatar', {
    staticStyle: {
      "background-color": "#87d068"
    },
    attrs: {
      "icon": "person",
      "size": "large"
    }
  })], 1), _vm._v(" "), _c('dd', {
    staticStyle: {
      "margin": "12px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.userDetail.nickName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "20px",
      "color": "rgb(120,145,150)"
    }
  }, [_vm._v("@" + _vm._s(_vm.userDetail.nickName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("关注")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("个人简介")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "projecrDesc"
  }, [_vm._v("项目描述：\n\t\t\t\t" + _vm._s(_vm.project.projectDesc) + " \n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "postingbottom",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('p', [_c('span', {
    staticStyle: {
      "margin-left": "50px"
    }
  }, [_c('Icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "转发",
      "type": "forward",
      "size": "20"
    }
  })], 1), _vm._v("    \n\t\t\t\t\t"), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#A9A9A9",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.commentsshow
    }
  }, [_vm._v("评论   |")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('Icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "thumbsup",
      "size": "20"
    },
    on: {
      "click": _vm.supportProject
    }
  }), _vm._v(_vm._s(_vm.project.supportNumber) + "\n\t\t\t\t\t\t \n\t\t\t\t\t\t"), _c('Icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "thumbsdown",
      "size": "20"
    },
    on: {
      "click": _vm.opposeProject
    }
  }), _vm._v(_vm._s(_vm.project.opposeNumber) + "\n\t\t\t\t\t")], 1), _vm._v(" "), _c('span', {
    staticClass: "posting_shape",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('Icon', {
    staticClass: "shape_twitter",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "分享到推特",
      "type": "social-twitter",
      "size": "20"
    }
  }), _vm._v("  \n\t\t\t\t\t\t"), _c('Icon', {
    staticClass: "shape_facebook",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "分享到脸书",
      "type": "social-facebook",
      "size": "20"
    }
  }), _vm._v("  \n\t\t\t\t\t\t"), _c('Icon', {
    staticClass: "shape_google",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "分享到谷歌",
      "type": "social-google",
      "size": "20"
    }
  }), _vm._v("  \n\t\t\t\t\t\t"), _c('Icon', {
    staticClass: "shape_reddit",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "shape on reddit",
      "type": "social-reddit",
      "size": "20"
    }
  }), _vm._v("  \n\t\t\t\t\t\t"), _c('Icon', {
    staticClass: "shape_linkedin",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "分享到linkedin",
      "type": "social-linkedin",
      "size": "20"
    }
  }), _vm._v("  \n\t\t\t\t\t")], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowcomments),
      expression: "isShowcomments"
    }],
    staticClass: "projectComment"
  }, [_c('Form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "commentProjectId"
    }
  }, [_c('Input', {
    attrs: {
      "type": "hidden"
    },
    model: {
      value: (_vm.formValidate.commentProjectId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "commentProjectId", $$v)
      },
      expression: "formValidate.commentProjectId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "commentText"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formValidate.commentText),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "commentText", $$v)
      },
      expression: "formValidate.commentText"
    }
  })], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitComment('formValidate')
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        return _vm.closeComment('formValidate')
      }
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px",
      "border-bottom": "1px solid rgb(238,238,238)",
      "border-top": "1px solid rgb(238,238,238)",
      "margin-top": "20px",
      "background-color": "#A9A9A9"
    }
  }), _vm._v(" "), _vm._l((_vm.projectCommentList), function(comment, index) {
    return _c('div', {
      staticClass: "comments",
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('dl', {
      staticStyle: {
        "display": "flex",
        "font-family": "inherit",
        "font-size": "14px"
      }
    }, [_c('dt', [_c('Avatar', {
      staticStyle: {
        "background-color": "#87d068"
      },
      attrs: {
        "icon": "person",
        "size": "large"
      }
    })], 1), _vm._v(" "), _c('dd', [_c('span', [_c('a', [_vm._v(_vm._s(_vm.userDetail.nickName))]), _vm._v(" 发表于")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(comment.commentTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Icon', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "thumbsup",
        "size": "20"
      },
      on: {
        "click": function($event) {}
      }
    }), _vm._v(_vm._s(comment.supportNumber) + "\n\t\t\t\t\t\t \n\t\t\t\t\t\t"), _c('Icon', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "thumbsdown",
        "size": "20"
      },
      on: {
        "click": function($event) {}
      }
    }), _vm._v(_vm._s(comment.opposeNumber) + "\n\t\t\t\t\t\t"), _c('span', {
      staticClass: "toggletext",
      staticStyle: {
        "margin-left": "400px",
        "color": "rgb(224,224,224)",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.toggletext(index)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "chevron-down"
      },
      on: {
        "click": _vm.q
      }
    })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isShowCommentText),
        expression: "isShowCommentText"
      }],
      staticClass: "commentText"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(comment.commentText) + "\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _vm._l((comment.projectCommentList), function(childComment) {
      return _c('div', {
        staticStyle: {
          "margin-left": "40px"
        }
      }, [_c('br'), _vm._v(" "), _c('dl', {
        staticStyle: {
          "display": "flex",
          "font-family": "inherit",
          "font-size": "14px"
        }
      }, [_c('dt', [_c('Avatar', {
        staticStyle: {
          "background-color": "#87d068"
        },
        attrs: {
          "icon": "person",
          "size": "large"
        }
      })], 1), _vm._v(" "), _c('dd', [_c('span', [_c('a', [_vm._v(_vm._s(_vm.userDetail.nickName))]), _vm._v(" 发表于")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(childComment.commentTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Icon', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "type": "thumbsup",
          "size": "20"
        },
        on: {
          "click": function($event) {}
        }
      }), _vm._v(_vm._s(childComment.supportNumber) + "\n\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t"), _c('Icon', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "type": "thumbsdown",
          "size": "20"
        },
        on: {
          "click": function($event) {}
        }
      }), _vm._v(_vm._s(childComment.opposeNumber) + "\n\t\t\t\t\t\t\t"), _c('span', {
        staticClass: "toggletext",
        staticStyle: {
          "margin-left": "300px",
          "color": "rgb(224,224,224)",
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            return _vm.toggletext(index)
          }
        }
      }, [_c('Icon', {
        attrs: {
          "type": "chevron-down"
        },
        on: {
          "click": _vm.q
        }
      })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.isShowCommentText),
          expression: "isShowCommentText"
        }],
        staticClass: "commentText"
      }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(childComment.commentText) + "\n\t\t\t\t\t\t\t")])], 1)])])
    })], 2)
  })], 2)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v(" ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bed42c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/project/ProjectDetail.vue
// module id = 419
// module chunks = 0